import { jws, b64utoutf8 } from 'jsrsasign';
import {isSchoolBlocksApp} from "./SchoolBlocksUtilities";

export function encodeCS (organizationId, userId, apiKey, spinup, facebookUserAccessToken, language, sessid = null) {
    // Header
    const header = {
        typ: 'JWT',
        alg: 'HS256',
    };

    const tNow = jws.IntDate.get('now');
    const tEnd = jws.IntDate.get('now + 1day');

    // Payload
    const payload = {
        iss: isSchoolBlocksApp() ? "schoolblocks.com" : "cleversite.com", // issuer
        aud: isSchoolBlocksApp() ? "schoolblocks.com" : "cleversite.com", // audience
        nbf: tNow - (60 * 10), // never before 10 minutes prior to request
        iat: tNow, // issued at
        exp: tEnd, // expiration time
        spinup: spinup,
        orgId: organizationId,
        userId: userId,
        apiKey: apiKey,
        language: language,
        sessid,
    };

    if (facebookUserAccessToken) {
        payload.facebookUserToken = facebookUserAccessToken;
    }

    // Sign JWT, password=616161
    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);
    return jws.JWS.sign("HS256", sHeader, sPayload, "J7!pO5OVWSGDhk0uWvy$pPYL");
}

export default class JSONWebToken {
    algorithm = 'HS256';
    CS_password = "J7!pO5OVWSGDhk0uWvy$pPYL";
    SB_password = 'school-blocks-key';

    constructor() {

    }

    encode(organizationId, url, sessid = null) {
        // Header
        const header = {
            typ: 'JWT',
            alg: this.algorithm,
        };

        const tNow = jws.IntDate.get('now');
        const tEnd = jws.IntDate.get('now + 1day');

        // Payload
        const payload = {
            iss: isSchoolBlocksApp() ? "schoolblocks.com" : "cleversite.com", // issuer
            aud: isSchoolBlocksApp() ? "schoolblocks.com" : "cleversite.com", // audience
            nbf: tNow - (60 * 10), // never before 10 minutes prior to request
            iat: tNow, // issued at
            exp: tEnd, // expiration time
            orgid: organizationId,
            returnUrl: url,
            sessid,
        };

        // Sign JWT, password=616161
        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        return jws.JWS.sign("HS256", sHeader, sPayload, this.SB_password);
    }

    decode(jwt) {
        // TODO: the isValid piece isn't working, but it should be!
        //const isValid = jws.JWS.verifyJWT(jwt, this.password, {alg: [this.algorithm]});

        let payloadObj = null;

        const jwtParts = jwt.split(".");
        if (jwtParts.length >= 2) {
            const jwtPayload = jwtParts[1];
            payloadObj = jws.JWS.readSafeJSONString(b64utoutf8(jwtPayload));
        }

        return payloadObj;
    }
}
